<svelte:options runes={true} />

<script lang="ts">
  import type { Command, CommandManager } from '@commands';
  import { CommandId } from '@commands';
  import type { UndoManager } from '@reactive';
  import { isActivationEvent, SlFontSize, SlTooltipPlacement } from '@ui';
  import { expectDefined } from '@utils';
  import CommandTooltip from './CommandTooltip.svelte';
  import Icon from './Icon.svelte';

  let {
    commandManager,
    undoManager
  }: {
    commandManager: CommandManager;
    undoManager: UndoManager;
  } = $props();
</script>

<style>
  .undo-redo-row {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
  }
  .undo-redo-row sl-button {
    flex: 1 1 0;
    --sl-spacing-small: 0; /* minimize internal padding adjustments if needed */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .undo-redo-row sl-button::part(base) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .undo-redo-row sl-button::part(label) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
</style>

{#snippet button(command: Command, disabled: boolean, action: () => void, note?: string)}
  <CommandTooltip {command} {note} placement={SlTooltipPlacement.RIGHT}>
    <sl-button
      class="fl-default-cursor"
      {disabled}
      onclick={action}
      onkeydown={(event: KeyboardEvent) => {
        if (isActivationEvent(event)) {
          action();
        }
      }}
      role="button"
      size="small"
      tabindex="0"
    >
      <Icon icon={expectDefined(command.icon)} inline size={SlFontSize.LG} />
    </sl-button>
  </CommandTooltip>
{/snippet}

<div class="undo-redo-row">
  {@render button(
    commandManager.getCommand(CommandId.UNDO),
    !undoManager.canUndo,
    () => undoManager.revertToLastUndoState(),
    undoManager.undoNote
  )}
  {@render button(
    commandManager.getCommand(CommandId.REDO),
    !undoManager.canRedo,
    () => undoManager.revertToLastRedoState(),
    undoManager.redoNote
  )}
</div>
